import type { TenantConfig } from '@/types/TenantConfig'

export const audubon: TenantConfig = {
  logo: 'assets/audubon/static/logo.svg',
  themeOptions: {
    dialog: {
      headerBackground: '#000000',
      headerTextColor: '#ffffff',
      headerIconColor: '#ffffff',
      headerBorder: '0',
    },
    mobileFooter: {
      cartButtonBorder: '1px solid #d4d4d4',
      cartButtonIconColor: '#d4d4d4',
      textColor: '#262626',
      priceTextColor: '#262626',
    },
  },
  teaserImageSize: {
    height: 224,
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet:
        'https://fonts.googleapis.com/css2?family=Noto+Serif:ital,wght@0,400;0,700;1,400;1,700&display=swap',
    },
  },
  i18nOverrides: {
    en: {
      reserveDateFirst: {
        pickFlexibleTickets: 'Buy an Any Day Pass',
      },
    },
  },
}
